export enum BUSINESS_RESULT_ORIGIN {
  TRIPIAN = 'Tripian',
  GOOGLE = 'Google',
}
